<template>
  <section class="TheAccessibilityPolicy">
    <h2 class="TheAccessibilityPolicy_Heading">
      Grove Collaborative Accessibility Statement
    </h2>
    <p class="TheAccessibilityPolicy_EffectiveDate">
      Effective Date: March 15, 2021
    </p>

    <PoliciesGrovePronounDisclaimer />

    <p>
      If you have difficulty using or accessing the Grove Collaborative
      Services, please call us at
      <SkyLink inline to="tel:1-844-476-8375" tag="a">1-844-476-8375</SkyLink>
      or contact us at
      <SkyLink inline to="mailto:support@grove.co" tag="a"
        >support@grove.co</SkyLink
      >
      and we will work with you to provide the information, item, or transaction
      you seek through a communication method that is accessible for you
      consistent with applicable law.
    </p>

    <p>
      Grove Collaborative is committed to providing a positive experience to all
      our customers and we aim to facilitate the accessibility and usability of
      our website and mobile applications. Our goal is to permit our customers
      to successfully gather information and transact business through our
      website and mobile applications, regardless of technology or ability. We
      are making efforts to maintain and increase the accessibility of our
      website and mobile applications to ensure that persons with disabilities
      have full and equal enjoyment of the Grove Collaborative Services. We view
      accessibility as an ongoing effort and continually seek solutions that
      will bring all areas of our website and mobile applications to the same
      level of overall web accessibility.
    </p>

    <p>
      Please contact us at
      <SkyLink inline to="tel:1-844-476-8375" tag="a">1-844-476-8375</SkyLink>
      or
      <SkyLink inline to="mailto:support@grove.co" tag="a"
        >support@grove.co</SkyLink
      >
      if you have any feedback or suggestions as to how we could improve the
      accessibility of the Grove Collaborative Services.
    </p>
  </section>
</template>

<style lang="scss">
.TheAccessibilityPolicy {
  display: grid;
  row-gap: var(--spacing-3x);

  &_Heading {
    @include type-brand-heading('2');
    margin-top: var(--spacing-8x);
  }

  &_EffectiveDate {
    @include type-body('l', true);
    margin-bottom: var(--spacing-3x);
  }
}
</style>
